import { defineMessages, IntlShape } from "react-intl";

import { showModal } from "@mapmycustomers/ui";

const messages = defineMessages({
  ownerConfirmOk: {
    id: "companyRecordPane.details.changeOwnerConfirmation.ok",
    defaultMessage: "Yes, change owner",
    description: "Ok button title in the Change Owner Confirmation modal",
  },
  ownerConfirmText: {
    id: "companyRecordPane.details.changeOwnerConfirmation.description",
    defaultMessage:
      "Depending on your permissions, you may lose access to this record immediately.",
    description: "Text in the Change Owner Confirmation modal",
  },
  ownerConfirmTitle: {
    id: "companyRecordPane.details.changeOwnerConfirmation",
    defaultMessage: "Are you sure you want to change the owner of this record?",
    description: "Title of the Change Owner Confirmation modal",
  },
});

const showConfirmationIfOwnerChanged = (
  intl: IntlShape,
  ownerChanged: boolean,
  isCurrentUserOwner: boolean,
  saveChanges: () => void
) => {
  if (ownerChanged && !isCurrentUserOwner) {
    showModal({
      autoFocusButton: null,
      centered: true,
      content: intl.formatMessage(messages.ownerConfirmText),
      okButtonProps: { danger: true },
      okText: intl.formatMessage(messages.ownerConfirmOk),
      onOk: () => {
        saveChanges();
      },
      title: intl.formatMessage(messages.ownerConfirmTitle),
      type: "confirm",
    });
  } else {
    saveChanges();
  }
};

export default showConfirmationIfOwnerChanged;
